/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SettingAdminControllerSetBusinessInfoV1$Params {
  
    /**
     * 사업자 정보 Key-Value 객체
     */
    body: {
[key: string]: string;
}
}

export function settingAdminControllerSetBusinessInfoV1(http: HttpClient, rootUrl: string, params: SettingAdminControllerSetBusinessInfoV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, settingAdminControllerSetBusinessInfoV1.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

settingAdminControllerSetBusinessInfoV1.PATH = '/api/v1/settings/admin/business-info';
